import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { DialogBody } from '@/components/ui/dialog-extensions';
import { useIsMobile } from '@/hooks/useMobile';
import { cn } from '@/lib/utils';
import { VoiceOrderModalContent } from './VoiceOrderModalContent';
import type { ParsedOuvrage } from './VoiceOrderQuestionnaire';

interface ParsedOrder {
  ouvrages: ParsedOuvrage[];
  formula?: {
    name: string;
    strength?: string;
    exposure_class?: string;
    consistency?: string;
  };
  options?: string[];
  heure?: string;
  date?: string;
  comment?: string;
  confidence: number;
}

interface VoiceOrderModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOrderParsed?: (order: ParsedOrder, transcription: string) => void;
}

export const VoiceOrderModal: React.FC<VoiceOrderModalProps> = ({
  open,
  onOpenChange,
  onOrderParsed,
}) => {
  const isMobile = useIsMobile();

  // Ne pas rendre le contenu si le modal est fermé (évite d'initialiser useVoiceRecording / accès micro)
  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          "flex flex-col overflow-hidden max-h-[85vh] sm:max-w-lg"
        )}
      >
        <DialogHeader>
          <DialogTitle>Commande vocale</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <VoiceOrderModalContent
            onOpenChange={onOpenChange}
            onOrderParsed={onOrderParsed}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
